export const template8MockData = {
  businessName: "Luxe Creative Studio",
  description: "We transform bold ideas into stunning realities. Our award-winning team delivers world-class design, branding, and digital experiences that elevate businesses to new heights.",
  businessInfo: {
    name: "Luxe Creative Studio",
    tagline: "Where Vision Meets Excellence",
    category: "Creative Agency",
    description: "We transform bold ideas into stunning realities. Our award-winning team delivers world-class design, branding, and digital experiences that elevate businesses to new heights. With over a decade of industry expertise, we partner with ambitious brands to create lasting impact.",
    logo: null,
    heroImage: null,
    ctaText: "Start Your Project",
    ctaSecondaryText: "View Our Work"
  },
  services: [
    {
      name: "Brand Strategy",
      title: "Brand Strategy",
      description: "Craft a powerful brand identity that resonates with your audience and sets you apart from competitors.",
      icon: "Strategy",
      price: "From $2,500"
    },
    {
      name: "UI/UX Design",
      title: "UI/UX Design",
      description: "Create intuitive, beautiful digital experiences that delight users and drive meaningful engagement.",
      icon: "Design",
      price: "From $3,000"
    },
    {
      name: "Web Development",
      title: "Web Development",
      description: "Build high-performance websites and applications with cutting-edge technology and best practices.",
      icon: "Development",
      price: "From $5,000"
    },
    {
      name: "Digital Marketing",
      title: "Digital Marketing",
      description: "Amplify your reach with data-driven marketing strategies that deliver measurable results.",
      icon: "Marketing",
      price: "From $1,500/mo"
    },
    {
      name: "Motion Graphics",
      title: "Motion Graphics",
      description: "Bring your brand to life with captivating animations and video content that tells your story.",
      icon: "Motion",
      price: "From $2,000"
    },
    {
      name: "Photography",
      title: "Photography",
      description: "Capture stunning visuals that showcase your products, team, and brand personality.",
      icon: "Photography",
      price: "From $1,200"
    }
  ],
  photos: [
    {
      url: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
      alt: "Modern office workspace",
      caption: "Our creative workspace"
    },
    {
      url: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop",
      alt: "Team collaboration",
      caption: "Collaborative design sessions"
    },
    {
      url: "https://images.unsplash.com/photo-1558403194-611308249627?w=800&h=600&fit=crop",
      alt: "Design process",
      caption: "From concept to creation"
    },
    {
      url: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&h=600&fit=crop",
      alt: "Client presentation",
      caption: "Delivering exceptional results"
    },
    {
      url: "https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=800&h=600&fit=crop",
      alt: "Creative brainstorming",
      caption: "Innovation in action"
    },
    {
      url: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=600&fit=crop",
      alt: "Digital design work",
      caption: "Pixel-perfect execution"
    }
  ],
  testimonials: [
    {
      name: "Alexandra Chen",
      role: "CEO, TechVentures",
      rating: 5,
      review: "Luxe Creative transformed our entire brand presence. Their strategic approach and stunning execution exceeded all expectations. Revenue increased 40% within six months of launch.",
      image: null,
      date: "2024-03-15"
    },
    {
      name: "Marcus Williams",
      role: "Founder, GrowthLabs",
      rating: 5,
      review: "The most professional creative agency we've ever worked with. They don't just deliver designs—they deliver business results. Our conversion rates doubled after their redesign.",
      image: null,
      date: "2024-02-28"
    },
    {
      name: "Sophia Rodriguez",
      role: "Marketing Director, InnovateCo",
      rating: 5,
      review: "Incredible attention to detail and a truly collaborative process. They took time to understand our vision and delivered something beyond what we imagined possible.",
      image: null,
      date: "2024-01-20"
    },
    {
      name: "David Park",
      role: "CTO, FutureTech",
      rating: 5,
      review: "From concept to execution, the team at Luxe Creative demonstrated exceptional expertise. They're not just vendors—they're strategic partners in our success.",
      image: null,
      date: "2024-01-05"
    }
  ],
  contactInfo: {
    address: "450 Design District, Suite 200, San Francisco, CA 94105",
    phone: "(415) 555-0234",
    email: "hello@luxecreative.studio",
    website: "https://luxecreative.studio",
    workingHours: "Mon - Fri: 9:00 AM - 6:00 PM",
    sundayHours: "Closed on Weekends"
  },
  businessHours: [
    { day: 'Monday', open: '9:00 AM', close: '6:00 PM', isClosed: false },
    { day: 'Tuesday', open: '9:00 AM', close: '6:00 PM', isClosed: false },
    { day: 'Wednesday', open: '9:00 AM', close: '6:00 PM', isClosed: false },
    { day: 'Thursday', open: '9:00 AM', close: '6:00 PM', isClosed: false },
    { day: 'Friday', open: '9:00 AM', close: '6:00 PM', isClosed: false },
    { day: 'Saturday', open: '10:00 AM', close: '4:00 PM', isClosed: false },
    { day: 'Sunday', open: '', close: '', isClosed: true }
  ],
  location: {
    title: "Visit Our Studio",
    subtitle: "Experience creativity in person",
    address: "450 Design District, Suite 200, San Francisco, CA 94105",
    lat: 37.7749,
    lng: -122.4194
  },
  gmbFeed: [
    {
      id: "post1",
      type: "announcement",
      title: "Award-Winning Project Launch",
      summary: "We're thrilled to announce our latest project for TechVentures has won the Design Excellence Award. Thank you to our amazing team and client for this achievement.",
      date: "2024-03-20",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop"
    },
    {
      id: "post2",
      type: "event",
      title: "New Creative Director Joins Team",
      summary: "Welcome Sarah Mitchell, our new Creative Director with 15 years of experience at top agencies. Excited to see the fresh perspective she brings to our projects.",
      date: "2024-03-15",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=400&fit=crop"
    },
    {
      id: "post3",
      type: "offer",
      title: "Studio Expansion Announcement",
      summary: "We're expanding! Our new 5,000 sq ft studio space opens next month, featuring state-of-the-art facilities for photography, video production, and client presentations.",
      date: "2024-03-10",
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600&h=400&fit=crop"
    }
  ],
  socialMedia: {
    facebook: "https://facebook.com/luxecreative",
    twitter: "https://twitter.com/luxecreative",
    linkedin: "https://linkedin.com/company/luxecreative",
    instagram: "https://instagram.com/luxecreative"
  }
};

export default template8MockData;
